<app-section-wrapper-container>
	<div class="grid grid-cols-2 md:grid-cols-3 gap-4">
		@for (item of options(); track item.title) {
			@if (!item.hidden) {
				<button
					focus
					active
					[disabled]="item.disabled"
					(click)="item.function()"
					[class]="!item.disabled ? 'cursor-pointer hover-layer' : ''"
					ultra-action-button>
					<app-ultra-icon [svgIcon]="item.icon" />
					<p class="text-sm">{{ item.title | transloco }}</p>
				</button>
			}
		}
	</div>
</app-section-wrapper-container>
